import { useState, useEffect } from 'react';

export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowWidth;
};

export const useResponsiveColumns = () => {
    const width = useWindowWidth();

    if (width >= 1280) return 5;
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    if (width >= 480) return 2;
    return 1;
};

export const useCategoryColumns = () => {
    const width = useWindowWidth();

    if (width >= 1280) return 8;
    if (width >= 1024) return 6;
    if (width >= 768) return 4;
    if (width >= 480) return 3;
    return 2;
};
